module.exports = __webpack_public_path__ + "media/images/vp/headerimg.mobi-edac141e4d43fca7d3e243eb346b1c5a.jpg";